import { useState } from "react";
import { post } from "../networking/RequestService";
import moment from "moment";

const useTaskUpdate = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const updateTask = async ({
        taskId,
        taskText,
        currentDate,
        profileId,
        daysToAdd = 0,
        type,
        important,
        taskColour,
        assignedToIds,
        activityId,
        customerHappiness,
    }) => {
        setLoading(true);
        setError(null);
        try {
            const newDate =
                daysToAdd !== undefined && daysToAdd !== 0
                    ? moment(currentDate)
                          .add(daysToAdd, "days")
                          .valueOf()
                    : moment(currentDate).valueOf();

            const payload = {
                fn: "gorevGuncelle",
                gorevId: taskId,
                metin: taskText,
                zaman: newDate,
                guncelleProfilId: profileId,
                forceUpdate: 0,
            };

            if (type !== undefined) payload.taskType = type;
            if (important !== undefined) payload.important = important;
            if (taskColour !== undefined) payload.taskColour = taskColour;
            if (assignedToIds !== undefined) payload.assignedToIds = assignedToIds;
            if (activityId !== undefined) payload.activityId = activityId;
            if (customerHappiness !== undefined) payload.customerHappiness = customerHappiness;

            const response = await post(payload);
            return response;
        } catch (err) {
            setError(err);
            throw err;
        } finally {
            setLoading(false);
        }
    };

    return { updateTask, loading, error };
};

export default useTaskUpdate;
